/** Best-effort `navigator.storage.estimate` (browser origin quota). */
export async function readBrowserStorageEstimate(): Promise<{ quotaBytes: number; usageBytes: number } | null> {
  const est = globalThis.navigator?.storage?.estimate;
  if (typeof est !== 'function') return null;
  try {
    const s = await est.call(globalThis.navigator.storage);
    const q = s.quota;
    const u = s.usage;
    if (typeof q !== 'number' || typeof u !== 'number' || !Number.isFinite(q) || !Number.isFinite(u)) return null;
    return { quotaBytes: Math.max(0, q), usageBytes: Math.max(0, u) };
  } catch {
    return null;
  }
}
